export const BROADBAND_VAS_CATEGORY = 'broadband_vas';
export const ACCOUNT_VAS_CATEGORY = 'account_vas';

export const SINGLE_CARD_WIDTH = 340;
